<script>
import RealignmentItems from "./realignment-items.vue";
import {groupBy } from "lodash"
export default {
  components: {
    RealignmentItems,
  },
  props: {
    realignment: {
      type: Array,
      default: () => [],
    },
    status: {
      type: String,
      default: "",
    },
    manageBudget: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "deliveryUnit",
          label: "Delivery Unit",
          width: '300px'
        },
        {
          key: "description",
          label: "Description",
        },
        {
          key: "total",
          label: "Total",
          tdClass: "align-middle",
          width: '120px'
        },
        {
          key: "action",
          tdClass: "align-middle",
          width: '90px'
        },
      ],
      fetching: false,
    };
  },
  computed: {
    rows() {
      return this.realignment.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showDetails(row) {
      row.item.items = [];
      row.toggleDetails();
      row.item.showDetails = !row.item.showDetails;
      if (row.item.showDetails) {
        row.item.isLoading = true;
        this.$store
          .dispatch("realignmentrequestitem/GetRealignmentItem", row.item.id)
          .then((response) => {
            if (response.data.error) {
              return this.showToast(response.data.errorMessage, "error");
            }
            let group = [];
            response.data.map(item => {
                item.totalQ1 = 0;
                item.totalQ2 = 0;
                item.totalQ3 = 0;
                item.totalQ4 = 0;
                item.realignmentRequestItems.map(x => {
                    if(x.apiResourceDetail.month.quarter == 1){
                        item.totalQ1 += x.total;
                    }
                    if(x.apiResourceDetail.month.quarter == 2){
                        item.totalQ2 += x.total;
                    }
                    if(x.apiResourceDetail.month.quarter == 3){
                        item.totalQ3 += x.total;
                    }
                    if(x.apiResourceDetail.month.quarter == 4){
                        item.totalQ4 += x.total;
                    }
                })
                item.apiName = item.api.name;
                item.groupName = item.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.groupName;
                item.groupId = item.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.id;
                item.fundSource = item.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.fundSource.shortName;
            })
            let groupByApi = groupBy(response.data, 'apiId');
            for(let key in groupByApi){
                let groupByAccount = groupBy(groupByApi[key], 'groupId');
                let gAcc = [];
                let q1 = 0;
                let q2 = 0;
                let q3 = 0;
                let q4 = 0;
                let total = 0;
                for(let g in groupByAccount){
                    let totalAQ1 = 0;
                    let totalAQ2 = 0;
                    let totalAQ3 = 0;
                    let totalAQ4 = 0;
                    let totalA = 0;
                    groupByAccount[g].map(a => {
                        totalA += parseFloat(a.total);
                        totalAQ1 += parseFloat(a.totalQ1);
                        totalAQ2 += parseFloat(a.totalQ2);
                        totalAQ3 += parseFloat(a.totalQ3);
                        totalAQ4 += parseFloat(a.totalQ4);
                        q1 += parseFloat(a.totalQ1);
                        q2 += parseFloat(a.totalQ2);
                        q3 += parseFloat(a.totalQ3);
                        q4 += parseFloat(a.totalQ4);
                        total += parseFloat(a.total);
                    })
                    gAcc.push({
                        accountId: groupByAccount[g][0].groupId,
                        account: groupByAccount[g][0].groupName,
                        fundSource: groupByAccount[g][0].fundSource,
                        total: totalA,
                        totalQ1: totalAQ1,
                        totalQ2: totalAQ2,
                        totalQ3: totalAQ3,
                        totalQ4: totalAQ4,
                        items: groupByAccount[g]
                    })
                }
                group.push({
                    api: groupByApi[key][0].apiName,
                    apiId: groupByApi[key][0].apiId,
                    accounts: gAcc,
                    q1: q1,
                    q2: q2,
                    q3: q3,
                    q4: q4,
                    total: total,
                })
            }
            row.item.isLoading = false;
            row.item.items = group;
          })
          .catch((error) => {
            row.item.isLoading = false;
            this.showToast("Cannot fetch requested items", "error");
          });

        this.$store
          .dispatch("realignmentaccount/GetAllRealignmentAccount", row.item.id)
          .then((response) => {
            if (response.data.error) {
              return this.showToast(response.data.errorMessage, "error");
            }
            row.item.accounts = response.data;
          })
          .catch((error) => {
            this.showToast("Cannot fetch requested accounts", "error");
          });
      }
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    approveRequest(data) {
      this.$swal({
        title: "Are you sure?",
        html: `You are now approving this realignment request of <span class="text-warning">${data.deliveryUnit}</span>. Do you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, approve it!",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("approveRequest", data);
        }
      });
    },
    returnRequest(data) {
      this.$swal({
        title: "Are you sure?",
        html: `You are now returning this realignment request of <span class="text-warning">${data.deliveryUnit}</span>. Do you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, return it!",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("returnRequest", data);
        }
      });
    },
    cascadeLIB() {
      this.$router.push("/finance/planning/cascaded-lib");
    },
    viewModifItems(items) {
      this.$emit("view-modif-items", items);
    },
    generateReport(){
      this.$emit('generate-report')
    }
  },
};
</script>
<template>
  <div class="mt-3">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              class="form-select form-select-sm mx-1"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select
            >&nbsp;entries
          </label>
        </div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm mx-2"
            ></b-form-input>
            <button type="button" class="btn btn-purple btn-sm no-wrap" @click="generateReport"><i class="bx bx-printer me-1"></i>Generate Report</button>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>
    <div class="custom-table-responsive mb-3">
      <b-table
        class="table-nowrap mb-0"
        :items="realignment"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        :busy="$store.state.realignmentrequest.isPostedRealignmentLoading"
        @filtered="onFiltered"
        show-empty
      >
        <template #empty="scope">
          <div class="text-center">
            <h5 class="text-secondary mb-0">{{ scope.emptyText }}</h5>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center">
            <h5 class="text-secondary mb-0">
              <i class="bx bx-hourglass bx-spin me-2"></i> Fetching data...
            </h5>
          </div>
        </template>
        <template #cell(total)="row">
          <span class="text-warning">{{ formatCurrency(row.item.total) }}</span>
        </template>
        <template #cell(deliveryUnit)="row">
          <p class="text-white mb-0">
            {{ row.item.deliveryUnit ? row.item.deliveryUnit : "-" }}
          </p>
          <p class="mb-0">
            <small
              role="button"
              @click="showDetails(row)"
              class="text-info align-middle"
              >View Items</small
            >
            <i
              class="bx bx-right-arrow-alt align-middle ms-2 text-info rotate"
              :class="{
                'rotate-90': row.item.showDetails,
              }"
            ></i>
          </p>
        </template>
        <template #cell(action)="row">
          <b-button
            variant="link"
            size="sm"
            :id="`popover-target-${row.item.id}`"
          >
            <i class="fas fa-ellipsis-h"></i>
          </b-button>
          <b-popover
            :target="`popover-target-${row.item.id}`"
            triggers="hover blur"
            placement="leftbottom"
            variant="secondary"
            custom-class="p-0 p-custom-class"
          >
            <b-list-group class="w-100 fit">
              <b-list-group-item
                button
                action
                @click="approveRequest(row.item)"
                v-if="status && status === 'requested' && manageBudget"
              >
                <i
                  class="bx bx-check align-middle me-2 text-info font-size-16"
                ></i>
                <span class="align-middle">Approve</span>
              </b-list-group-item>
              <b-list-group-item
                button
                action
                @click="returnRequest(row.item)"
                v-if="status && status === 'requested' && manageBudget"
              >
                <i
                  class="bx bx-left-arrow-alt align-middle me-2 text-warning font-size-16"
                ></i>
                <span class="align-middle">Return</span>
              </b-list-group-item>
              <!-- <b-list-group-item button
                                 action
                                 @click="cascadeLIB()"
                                 v-if="status && status === 'approved'">
                <i class="bx bx-exit align-middle me-2 text-warning font-size-16"></i>
                <span class="align-middle">Cascade LIB</span>
              </b-list-group-item> -->
              <b-list-group-item
                button
                action
                @click="$emit('print', row.item.id)"
              >
                <i
                  class="bx bx-printer align-middle me-2 text-purple font-size-16"
                ></i>
                <span class="align-middle">Print Modification of Budget</span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </template>
        <template #row-details="row">
          <RealignmentItems
            :items="row.item.items"
            :record="row.item"
            :api="row.item.api"
            :accounts="row.item.accounts"
            :tableBusy="row.item.isLoading"
            @view-items="viewModifItems"
          >
          </RealignmentItems>
        </template>
      </b-table>
    </div>
    <div class="row mb-2">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
